import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import TimeDisplay from 'components/TimeDisplay';
import Distance from 'components/Distance';

const Destinations = ({
  className,
  withStops,
  start_time_from,
  start_time_to,
  label_from,
  country_from,
  end_time_from,
  end_time_to,
  label_to,
  country_to,
  distance,
  stops,
  start_time_from_tz,
  start_time_to_tz,
  end_time_from_tz,
  end_time_to_tz,
}) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <div className="destinations" data-testid="destinations">
        <div className="destinations__from">
          <div className="destinations__time">
            <TimeDisplay
              time_from={start_time_from}
              time_to={start_time_to}
              time_from_tz={start_time_from_tz}
              time_to_tz={start_time_to_tz}
            />
          </div>
          <div className="destinations__localization">{`${country_from} ${label_from}`}</div>
        </div>
        <div className="destinations__arrow">
          <Icon glyph="up" size="1rem" />
        </div>
        <div className="destinations__to">
          <div className="destinations__time">
            <TimeDisplay
              time_from={end_time_from}
              time_to={end_time_to}
              time_from_tz={end_time_from_tz}
              time_to_tz={end_time_to_tz}
            />
          </div>
          <div className="destinations__localization">{`${country_to} ${label_to}`}</div>
        </div>
        {withStops && (
          <div className="destinations__stops">
            {distance !== undefined && (
              <div className="destinations__distance">
                <Distance distance={distance} />
              </div>
            )}
            {stops > 2 && (
              <div className="destinations__stops-number">
                {t('Offers:stopWithCount', { count: stops })}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

Destinations.defaultProps = {
  withStops: false,
  country_from: '',
  country_to: '',
};

Destinations.propTypes = {
  withStops: PropTypes.bool,
  start_time_from: PropTypes.string.isRequired,
  start_time_from_tz: PropTypes.string.isRequired,
  start_time_to: PropTypes.string.isRequired,
  start_time_to_tz: PropTypes.string.isRequired,
  label_from: PropTypes.string.isRequired,
  country_from: PropTypes.string.isRequired,
  end_time_from: PropTypes.string.isRequired,
  end_time_from_tz: PropTypes.string.isRequired,
  end_time_to: PropTypes.string.isRequired,
  end_time_to_tz: PropTypes.string.isRequired,
  label_to: PropTypes.string.isRequired,
  country_to: PropTypes.string.isRequired,
  distance: PropTypes.number,
  stops: PropTypes.number,
};

export default Destinations;
